module.exports = __webpack_public_path__ + "img/plan.cff6a6f4.jpg";